/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useEffect } from 'react';
import { Grid, Fade } from '@mui/material';
import { useSelector } from 'react-redux';
import styles from 'modules/dashboard/components/tab-container/tab-container.module.scss';
import Widget from './pace-widgets';
import { selectTabList } from '../../../../../selectors';
/**
 * Pace test widget parent component. Reuses pace-tabs' filter widgets, data-fetching
 * saga and orchestration hooks (already running via the pace-tabs PaceWidget) and only
 * provides an independent tab entry/UI layer.
 * @param {Number} value - Pace test widget tab value
 * @param {Boolean} active - whether pace test tab is active
 */
const PaceTestWidget = ({ active, value, latestDate, reportType, hotelTimezone, toggleDisabled }) => {
  // Triggered when tab value or active tab change
  const TAB_VALUE = useSelector(selectTabList);
  useEffect(() => {
    // Scroll up when the pace test tab is clicked
    if (value === TAB_VALUE.PACE_TEST) window.scrollTo(0, 0);
  }, [value, active]);
  //
  return (
    active && (
      <Fade in={active} {...{ timeout: 500 }}>
        <Grid
          container
          direction="row"
          sx={{
            display: value === TAB_VALUE.PACE_TEST ? '' : 'none',
          }}
          className={styles.mainGrid}
          alignItems="flex-start"
        >
          <Widget
            value={value}
            latestDate={latestDate}
            reportType={reportType}
            hotelTimezone={hotelTimezone}
            toggleDisabled={toggleDisabled}
          />
        </Grid>
      </Fade>
    )
  );
};
//
export default PaceTestWidget;
